import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { setReferralSources, setAidCookie } from '@fundera/fundera-utilities';
import Newsletter from '../Newsletter';
import Footer from '../Footer';
import './styles.less';

const SiteLayout = ({ children, header }) => {
  useEffect(() => {
    setReferralSources();
    setAidCookie();
  }, []);

  return (
    <div>
      {header}
      {children}
      <Newsletter />
      <Footer />
    </div>
  );
};

SiteLayout.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.node.isRequired,
};

export default SiteLayout;
